export default __webpack_public_path__ + "static/media/gitlab.c99d619c.png";